module.exports = __webpack_public_path__ + "img/route_4.09f2aa38.png";